<template>
  <div class="wrap">
    <div class="tabs">
      <div class="mainNav">
        <router-link to="/home" class="item">
          <i :class="$route.name === 'Home' ? 'active' : ''" class="iconfont icon-home"></i>
          <p>{{$t('t.Home')}}</p>
        </router-link>
        <router-link to="/invest/list" class="item">
          <i :class="$route.name === 'Order' ? 'active': '' " class="iconfont icon-chart-simple"></i>
          <p>{{$t('t.Markets')}}</p>
        </router-link>
<!--        <div class="centerCircle"></div>-->
<!--        <router-link to="/message" class="item"><i class="iconfont icon-csr"></i></router-link>-->
        <router-link to="/trade" class="item">
          <i :class="$route.name === 'Invest' ? 'active': '' " class="iconfont icon-trade"></i>
          <p>{{$t('t.Trade')}}</p>
        </router-link>
        <router-link to="/user" class="item">
          <i :class="$route.name === 'User' ? 'active': '' " class="iconfont icon-statistics"></i>
          <p>{{$t('page.setting')}}</p>
        </router-link>
      </div>
<!--      <div :class="this.$route.name === 'Member' ? 'active' : ''" class="centerRouter" @click="$router.push('/member')" ></div>-->
    </div>
    <router-view class="content" />
  </div>
</template>

<script>
import {isLogin, getType} from '@/utils/auth'
import App from './topbar'
export default {
  name: 'App',
  components: {App},
  data () {
    return {
      type: getType(),
      showPopover: false,
      isLogin: false,
      nowLang: this.$i18n.locale
    }
  },
  methods: {
  },
  mounted () {
    if (isLogin()) {
      this.isLogin = true
    }
  }
}
</script>

<style lang="less">
.tabs {
  box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.33);
  background: none;
  height: 4rem;
  position: fixed;
  left: 0rem;
  right: 0rem;
  bottom:0rem;
  background: #333;
  padding: 0;
  z-index: 99;
  .centerRouter.active{
    background-image: url("../../assets/images/menu-active.png");
  }
  .centerRouter{
    width:4rem;
    height:4rem;
    background-image: url("../../assets/images/menu.png");
    background-size: contain;
    position: absolute;
    top: -0.5rem;
    left: 50%;
    margin-left: -2rem;
    z-index: 2;
  }
  .mainNav{
    display:flex;
    overflow: hidden;
    z-index: 1;
    a.active{
      color: #FFD7A6;
      opacity: 1;
      p{
        color: #FFD7A6;
      }
    }
    a{
      flex: 1;
      text-align: center;
      display: block;
      color: #fff;
      opacity: .5;
      padding-top: .5rem;
      i{
        font-size: 1.7rem;
        display: block;
        height: 2rem;
        line-height: 2rem;
      }
      p{
        font-size: .7rem;
        line-height: 1rem;
        height: 1rem;
        color: #fff;
      }
    }
  }
}

.wrap {
  height: 100%;
  width: 100%;
  > .content {
    background: #333;
    position: absolute;
    top: 0rem;
    bottom: 4rem;
    left: 0;
    right: 0;
    overflow: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/layout/member.vue